export const onCreateProject = /* GraphQL */ `
  subscription onCreateProject {
    onCreateProject {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
      user {
        createdAt
        email
        gender
        id
        name
        owner
        updatedAt
      }
      likiees {
        nextToken
        items {
          id
          name
          model
          likieeItemId
          likieeSourceId
          mpn
          owner
          price
          priceRange {
            min
            max
            currency
            count
          }
          images
          imageURL
          descriptionHtml
          description
          currency
          color
          createdAt
          canonicalUrl
          breadcrumbs
          additionalProperty
          aggregateRating
          availability
          brand
          priceAlertId
          probability
          regularPrice
          sku
          sortHash
          status
          supportedLocales
          upc
          thumbnailURLs
          updatedAt
          url
          priceAlert {
            alertWhenGetsCheaper
            likieeId
            originalPrice
            alertPriceMin
            id
          }
          historicalPrices {
            availability
            currency
            currencyRaw
            date
            price
            regularPrice
          }
        }
      }
    }
  }
`;

export const onDeleteProject = /* GraphQL */ `
  subscription onDeleteProject {
    onDeleteProject {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
      user {
        createdAt
        email
        gender
        id
        name
        owner
        updatedAt
      }
      likiees {
        nextToken
        items {
          id
          name
          model
          likieeItemId
          likieeSourceId
          mpn
          owner
          price
          priceRange {
            min
            max
            currency
            count
          }
          images
          imageURL
          descriptionHtml
          description
          currency
          color
          createdAt
          canonicalUrl
          breadcrumbs
          additionalProperty
          aggregateRating
          availability
          brand
          priceAlertId
          probability
          regularPrice
          sku
          sortHash
          status
          supportedLocales
          upc
          thumbnailURLs
          updatedAt
          url
          priceAlert {
            alertWhenGetsCheaper
            likieeId
            originalPrice
            alertPriceMin
            id
          }
          historicalPrices {
            availability
            currency
            currencyRaw
            date
            price
            regularPrice
          }
        }
      }
    }
  }
`;

export const onUpdateProject = /* GraphQL */ `
  subscription onUpdateProject {
    onUpdateProject {
      createdAt
      icon
      id
      itemsCount
      name
      owner
      updatedAt
      visibility
      visibilityGroup
      likiees {
        items {
          id
        }
      }
    }
  }
`;
